import { render, staticRenderFns } from "./BaseAlertDialog.vue?vue&type=template&id=6faa81e4&scoped=true"
import script from "./BaseAlertDialog.vue?vue&type=script&lang=js"
export * from "./BaseAlertDialog.vue?vue&type=script&lang=js"
import style0 from "./BaseAlertDialog.vue?vue&type=style&index=0&id=6faa81e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faa81e4",
  null
  
)

export default component.exports